// @ts-ignore
import styles from './EducationMaterialsItem.module.scss';
import Checkbox from '../Base/Checkbox/Checkbox';
import { EducationMaterialInterface } from '../../Models/EducationMaterials/EducationMaterial';
import useTranslation from '../../Hooks/useTranslation';
import FormattedDate from '../FormattedDate';
import React from 'react';
import Text from '../Base/Text/Text';

interface EducationMaterialsItemProps {
	item: EducationMaterialInterface;
	onUpdateItem: (item) => void;
}

export default function EducationMaterialsItem(
	props: EducationMaterialsItemProps,
) {
	const { item, onUpdateItem } = props;
	const { t } = useTranslation();

	const handleToggleActive = () => {
		item.active = !item.active;
		onUpdateItem(item);
	};

	const placeholder = '/dist/education-material.jpg';

	let component = undefined;
	switch (item.subtype) {
		case 'video':
			component = (
				<iframe
					style={{ aspectRatio: '16/9' }}
					src={item.value.playerLink}
					width={'100%'}
					height={'auto'}
					frameBorder={'0'}
					allow={'autoplay; fullscreen'}
					allowFullScreen
				/>
			);
			// component = <img src={item.value.preview} alt={item.name}/>;
			break;
		case 'pdf':
			component = (
				<a href={item.link} target='_blank'>
					<img src={item.value.preview ?? placeholder} alt={item.name} />
					<div className={styles.typeInfo}>
						{t('component.educationMaterialsItem.type.pdf')}
					</div>
				</a>
			);
			break;
		case 'image':
			component = (
				<div>
					<img src={item.value.preview ?? placeholder} alt={item.name} />
					<div className={styles.typeInfo}>
						{t('component.educationMaterialsItem.type.image')}
					</div>
				</div>
			);
			break;
		case 'link':
			component = (
				<a href={item.link} target='_blank'>
					<img src={item.value.preview ?? placeholder} alt={item.name} />
					<div className={styles.typeInfo}>
						{t('component.educationMaterialsItem.type.web')}
					</div>
				</a>
			);
			break;
	}

	return (
		<div className={styles.wrapper}>
			{item.sent && (
				<div className={styles.badge}>
					{t('base.sent2')}
					{item.sendAt && (
						<>
							: <FormattedDate date={item.sendAt} />
						</>
					)}
				</div>
			)}
			<div className={styles.content}>{component}</div>
			<Checkbox
				tx={item.name}
				onChange={handleToggleActive}
				value={item.active}
				className={styles.checkbox}
			/>
		</div>
	);
}
